import React from 'react'
import labels from 'settings/app/staticLabels'

export const TextContext = React.createContext()

/**
 * provides all strings to the application
 *
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export const TextContextProvider = ({ children }) => (
  <TextContext.Provider value={ labels }>{children}</TextContext.Provider>
)

export const TextContextConsumer = TextContext.Consumer

export const useTextContext = () => {
  const context = React.useContext(TextContext)
  if (context === undefined) {
    throw new Error('useTextContext must be used within a TextContextProvider')
  }
  return context
}
